import { motion } from 'framer-motion'

interface LogoProps {
  variant?: 'full' | 'static' | 'compact' | 'stacked'
  className?: string
}

export function Logo({ variant = 'static', className = '' }: LogoProps) {
  if (variant === 'compact') {
    return (
      <div className={`inline-flex items-baseline gap-[2px] ${className}`}>
        <span className="font-display font-light italic text-[1.1em] tracking-tightest">m</span>
        <span className="font-display font-normal text-[1em] tracking-tightest">·</span>
        <span className="font-display font-light italic text-[1.1em] tracking-tightest">m</span>
      </div>
    )
  }

  if (variant === 'stacked') {
    return (
      <div className={`inline-flex flex-col items-center leading-[0.85] ${className}`}>
        <span className="font-display font-light italic tracking-tightest text-[1em]">mile</span>
        <span className="font-display font-extralight italic text-taupe/70 text-[0.55em] tracking-[0.4em] uppercase my-1">to</span>
        <span className="font-display font-light italic tracking-tightest text-[1em]">mile</span>
      </div>
    )
  }

  const content = (
    <>
      <span className="font-display font-light italic tracking-tightest">mile</span>
      <span className="font-sans font-light text-taupe text-[0.5em] tracking-[0.35em] uppercase pb-[0.3em]">to</span>
      <span className="font-display font-light italic tracking-tightest">mile</span>
    </>
  )

  if (variant === 'full') {
    return (
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        className={`inline-flex items-baseline gap-[0.18em] ${className}`}
      >
        {content}
      </motion.div>
    )
  }

  // static: sem motion, evita re-animar em re-renders do Header
  return (
    <span className={`inline-flex items-baseline gap-[0.18em] ${className}`}>
      {content}
    </span>
  )
}
